module.exports = __webpack_public_path__ + "img/001.ed3c6f3b.png";